import React from 'react';
import { ATMDropdown } from 'shared-it-appmod-ui';
import Access from 'src/components/atoms/access/access.component';
import { AccessType, RequestStatus as ReqStatus } from 'src/constants';
import history from 'src/history';
import Lang from 'src/libraries/language';

import { isRequestAccessible } from 'src/selectors/request.selector';
import FlightRequestChangeStatus from '../flight-request-change-status/flight-request-change-status.component';
import FlightRequestEditCost from '../flight-request-edit-cost/flight-request-edit-cost.component';
import FlightRequestListUpload from '../flight-request-list/flight-request-list-upload/flight-request-list-upload.component';

type IProps = {
  isList?: boolean;
  requestId: number;

  requestStatus?: string | null;
  requestorNo?: string | null;
  flightCost?: string | null;
  type?: string;
  attachmentsCount?: number;
  handleCancelSuccess?: (data) => void;
  handleCancelClose?: () => void;
  handleCostStatusSuccess?: (data) => void;
};

const FlightRequestDropdown: React.FC<IProps> = ({
  isList = true,
  requestId,
  requestStatus,
  requestorNo,
  flightCost,
  type,
  attachmentsCount,
  handleCancelSuccess,
  handleCancelClose,
  handleCostStatusSuccess,
}) => {
  const params = {
    requestId,
    requestStatus,
    requestorNo,
  };
  const FlightCategoryDrone = ['droneInternal', 'droneExternal'];

  return (
    <ATMDropdown
      pointing
      icon="ellipsis horizontal"
      className="link item right top"
      color="grey"
    >
      <ATMDropdown.Menu>
        {isList && (
          <Access
            type={AccessType.FLIGHT_REQUEST_UPDATE}
            when={isRequestAccessible(params, AccessType.FLIGHT_REQUEST_UPDATE)}
          >
            <ATMDropdown.Item
              content={Lang.LBL_EDIT_REQUEST}
              onClick={() => history.push(`/flight/${type}/${requestId}/edit`)}
              icon="edit"
            />
          </Access>
        )}

        {requestStatus === ReqStatus.RequiresFlightCost && (
          <Access
            type={AccessType.FLIGHT_REQUEST_UPDATE_COST}
            when={isRequestAccessible(
              params,
              AccessType.FLIGHT_REQUEST_UPDATE_COST
            )}
          >
            <FlightRequestEditCost
              requestId={requestId}
              flightCost={flightCost ?? ''}
              handleCostStatusSuccess={(val) => handleCostStatusSuccess && handleCostStatusSuccess(val)}
            />
          </Access>
        )}

        {requestStatus !== ReqStatus.Cancelled &&
          attachmentsCount !== undefined && (
            <Access
              type={AccessType.FLIGHT_REQUEST_UPLOAD}
              when={isRequestAccessible(
                params,
                AccessType.FLIGHT_REQUEST_UPLOAD
              )}
            >
              <FlightRequestListUpload
                requestId={requestId}
                total={attachmentsCount}
              />
            </Access>
          )}

        {requestStatus !== ReqStatus.Cancelled && type && (
          <Access
            type={AccessType.FLIGHT_REQUEST_DUPLICATE}
            when={isRequestAccessible(
              params,
              AccessType.FLIGHT_REQUEST_DUPLICATE
            )}
          >
            <ATMDropdown.Item
              onClick={() =>
                history.push(`/flight/${type}/${requestId}/duplicate`)
              }
              content={Lang.LBL_DUPLICATE_REQUEST}
              icon="clone outline"
            />
          </Access>
        )}
        {requestStatus !== ReqStatus.Cancelled &&
          !FlightCategoryDrone.includes(type ?? 'patrolPassenger') && (
            <Access
              type={AccessType.FLIGHT_REQUEST_RISK_ASSESSMENT}
              when={isRequestAccessible(
                params,
                AccessType.FLIGHT_REQUEST_RISK_ASSESSMENT
              )}
            >
              <ATMDropdown.Item
                content={Lang.LBL_RISK_ASSESSMENT}
                onClick={() => history.push(`/flight/${requestId}/assessment`)}
                icon="list layout"
              />
            </Access>
          )}
        {requestStatus !== ReqStatus.Cancelled && (
          <Access
            type={AccessType.FLIGHT_REQUEST_CANCEL}
            when={isRequestAccessible(params, AccessType.FLIGHT_REQUEST_CANCEL)}
          >
            <FlightRequestChangeStatus
              requestId={requestId}
              trigger={(setIsOpen) => (
                <ATMDropdown.Item
                  content={Lang.LBL_CANCEL_FLIGHT}
                  icon="times circle outline"
                  onClick={() => setIsOpen(true)}
                />
              )}
              onSuccess={(val) => handleCancelSuccess && handleCancelSuccess(val)}
              onClose={handleCancelClose}
            />
          </Access>
        )}
      </ATMDropdown.Menu>
    </ATMDropdown>
  );
};

export default FlightRequestDropdown;
